module.exports = __webpack_public_path__ + "static/media/selo-mobal.02f9b812.png";